import EventActivityVue from '@/views/sic/event-activity/event-activity.vue';

const basePath = '/sic/event-activity';
const role = 'sic'; // 角色身份

export const SIC_EVENT_ACTIVITY_INDEX = 'sic-event-activity-index';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: EventActivityVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SIC_EVENT_ACTIVITY_INDEX,
      props: true,
      component: () => import(
        /* webpackChunkName: "event-activity-create" */
        `@/views/${role}/event-activity/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
